import { Box, Card, CardActionArea, CardContent, CardMedia, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useValue } from '../../../context/ContextProvider';
import CantidadDialog from './components/CantidadDialog'

const PosButtons = ({ imgVentas, addGeneral, addPan }) => {
    const { state: { productos } } = useValue();
    const [imgUrl, setImgUrl] = useState([]);
    const [nombreProductoState, setNombreProductoState] = useState('');
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(1);

    //URL del servidor donde se encuentran las imagenes de los productos
    const imgBaseUrl = "http://cerberusb.camtor.net:5000/static/images/";

    useEffect(() => {
        const newImgUrl = imgVentas?.sort((a, b) => a.pos - b.pos);
        setImgUrl(newImgUrl);
    }, [imgVentas])

    const handleImgClick = (nombreProducto) => {
        //console.log('Producto selecionado: ', nombreProducto);
        setOpen(true);
        setSelectedValue(1);
        setNombreProductoState(nombreProducto);
    }

    const addProduct = (nombreProducto, n) => {
        const productoEncontrado = productos.find((producto) => producto.product == nombreProducto);
        if (productoEncontrado?.type == 'Pan') {
            //La gestion del pan es diferente al resto de los productos
            addPan(productoEncontrado, n);
        } else {
            //El producto es general, no es pan
            if (productoEncontrado) {
                addGeneral(productoEncontrado, 1);
            } else {
                console.log('El shorcut gráfico no está correctamente configurado. No se encontro nombreProducto que corresponda.')
            }
        }
    }

    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
        //console.log({ value });
        addProduct(nombreProductoState, value);
    };

    return (
        <Box>
            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" justifyContent='right' paddingTop={2}>
                {imgUrl?.map((item, i) => (
                    <Card key={'card_' + i} variant="outlined" sx={{ width: '30%' }}>
                        <CardActionArea key={'cardAA_' + i}>
                            <CardMedia
                                key={'cardM_' + i}
                                //fullWidth
                                component="img"
                                height="100"
                                //image={imgBaseUrl + imgUrl?.find((img) => img.pos == (key+1))?.url}
                                image={imgBaseUrl + item.url}
                                alt="Pan Surtido"
                                onClick={() => { handleImgClick(item.product) }}
                            />
                            <CardContent key={'cardC_' + i}>
                                <Typography key={'typ_' + i} variant="button" component="div" pt={0} align='center' onClick={() => { handleImgClick(item.product) }}>
                                    {item.label}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                ))}
            </Stack>
            <CantidadDialog
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                nombreProductoState={nombreProductoState}
            />
        </Box>
    )
}

export default PosButtons